import { IPlayerStateTaskData } from "State/Player/IPlayerState";
import FarmFTUXTask from "Utility/Task/FarmFTUXTask";
import FarmPetFTUXTask from "Utility/Task/FarmPetFTUXTask";
import FarmSystem from "../FarmSystem";

export default class FarmTaskHelper {
    public static FarmFTUX(system: FarmSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new FarmFTUXTask());
    }
    public static FarmPetFTUX(system: FarmSystem, taskData: IPlayerStateTaskData): void {
        system.taskQueue.queue(new FarmPetFTUXTask());
    }
}